<template>
  <div>
    <Navbar @display-component="toggleDisplay" />
    <UserNotifications
      v-if="account.subscriptionType.toLowerCase()=='trial'"
      :createdOn="account.createdOn"
    />
    <UpgradeAccount @display-component="toggleDisplay" />

    <transition name="fade" v-if="display.upload" mode="out-in">
      <Upload @report-id="setReportID" :account="account" />
    </transition>
    <transition name="fade" v-if="display.mileageReport" mode="out-in">
      <ReportDisplay :report-name="reportID" />
    </transition>
    <transition name="fade" v-if="display.userPreferences" mode="out-in">
      <UserPreferences :account="account" />
    </transition>
    <transition name="fade" v-if="display.documentation" mode="out-in">
      <Documentation />
    </transition>
  </div>
</template>

<script>
import Navbar from "@/components/Navbar.vue";
import Upload from "@/components/Upload.vue";
import ReportDisplay from "@/components/ReportDisplay.vue";
import UserPreferences from "@/components/UserPreferences.vue";
import Documentation from "@/components/Documentation.vue";
import UserNotifications from "@/components/UserNotifications.vue";
import UpgradeAccount from "@/components/UpgradeAccount.vue";

export default {
  name: "MileLogix",
  components: {
    Navbar,
    Upload,
    ReportDisplay,
    UserPreferences,
    Documentation,
    UserNotifications,
    UpgradeAccount
  },
  data() {
    return {
      reportID: "",
      display: {
        mileageReport: false,
        upload: true,
        userPreferences: false,
        documentation: false
      },
      account: {
        fullName: "",
        email: "",
        companyName: "",
        subscriptionType: "",
        subscribedCalendarUsers: "",
        createdOn: ""
      }
    };
  },
  methods: {
    toggleDisplay(eventMessage) {
      switch (eventMessage) {
        case "upload":
          this.display.upload = true;
          this.display.mileageReport = false;
          this.display.userPreferences = false;
          this.display.documentation = false;
          this.getAccountDetails();
          break;

        case "mileageReport":
          this.display.upload = false;
          this.display.mileageReport = true;
          this.display.userPreferences = false;
          this.display.documentation = false;
          break;

        case "userPreferences":
          this.display.upload = false;
          this.display.mileageReport = false;
          this.display.userPreferences = true;
          this.display.documentation = false;
          this.getAccountDetails();
          break;

        case "documentation":
          this.display.upload = false;
          this.display.mileageReport = false;
          this.display.userPreferences = false;
          this.display.documentation = true;
          break;

        default:
          this.display.upload = true;
          this.display.mileageReport = false;
          this.display.userPreferences = false;
          this.display.documentation = false;
      }
    },
    setReportID(eventMessage) {
      this.reportID = eventMessage;
      this.toggleDisplay("mileageReport");
    },
    getAccountDetails: function() {
      this.$http
        .get(process.env.VUE_APP_API_URL + "/account")
        .then(httpResponse => {
          this.account.fullName = httpResponse.data.fullname;
          this.account.email = httpResponse.data.email;
          this.account.companyName = httpResponse.data.company_name;
          this.account.subscriptionType = httpResponse.data.subscription_type;
          this.account.subscribedCalendarUsers =
            httpResponse.data.subscribed_calendar_users;
          this.account.createdOn = httpResponse.data.account_created_on;
        })
        .catch(httpError => {
          if (httpError.response.status == 401) {
            localStorage.removeItem("token");
            this.$router.push("/");
          }
        });
    }
  },
  created: function() {
    this.getAccountDetails();
  }
};
</script>

<style scoped>
.fade-enter-active {
  transition: opacity 1.5s;
}
.fade-leave-active {
  opacity: 0;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
